var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-message--emoji"},[_vm._v(_vm._s(_vm.data.emoji))])
}
var staticRenderFns = []

export { render, staticRenderFns }